import { useChatTransport as e } from "../transport/ChatTransportContext.mjs";
import { useMutation as t, useQueryClient as n } from "@maat/store-hooks";
//#region src/hooks/useMarkReadMutation.ts
var r = () => {
	let r = n(), { api: i, keys: a } = e();
	return t({
		mutationFn: ({ conversationId: e, last_read_message_id: t }) => i.markRead(e, { last_read_message_id: t }),
		onMutate: async ({ conversationId: e }) => {
			let t = a.conversations?.();
			if (!t) return { previous: [] };
			await r.cancelQueries({ queryKey: t });
			let n = [];
			for (let { queryKey: i } of r.getQueryCache().findAll({ queryKey: t })) {
				let t = r.getQueryData(i);
				n.push([i, t]), t && r.setQueryData(i, {
					...t,
					pages: t.pages.map((t) => ({
						...t,
						conversations: t.conversations.map((t) => t.id === e ? {
							...t,
							unread_count: 0
						} : t)
					}))
				});
			}
			return { previous: n };
		},
		onError: (e, t, n) => {
			for (let [e, t] of n?.previous ?? []) r.setQueryData(e, t);
		},
		onSettled: () => {
			let e = a.unread?.();
			e && r.invalidateQueries({ queryKey: e });
		}
	});
};
//#endregion
export { r as useMarkReadMutation };
